import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  text = 'OBTENER ACCESO INSTANTÁNEO AL PROTOCOLO 22',
  subtext,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full max-w-xl mx-auto ${className}`} data-id="element-13">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick || (() => document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    }))} className="w-full bg-brand-blue hover:bg-brand-blueHover text-white font-display font-bold text-xl md:text-2xl py-5 px-8 rounded-none uppercase tracking-wide transition-colors shadow-[0_0_20px_rgba(59,130,246,0.3)]" data-id="element-14">
        {text}
      </motion.button>
      {subtext && <p className="mt-3 text-brand-lightGray text-sm text-center" data-id="element-15">
          {subtext}
        </p>}
    </div>;
}